<div class="row flex-nowrap h-100 cursor-pointer file-item font-m" data-uit="file-item">
    <div class="col-7 ps-4 d-flex align-items-center">
        <span class="text-truncate" data-uit="file-apeer-name">{{ file.name }}</span>
    </div>
    <div class="col-2 d-flex align-items-center justify-content-center">
        <span class="text-truncate">{{ file.sizeInBytes ? (file.sizeInBytes | fileSize) : '' }}</span>
    </div>
    <div class="d-flex align-items-center justify-content-center" [ngClass]="removeFiles && download ? 'col-1' : 'col-2'">
        <span class="text-truncate">{{ file.type }}</span>
    </div>
    <div
        class="d-flex flex-nowrap align-items-center justify-content-end action-column"
        [ngClass]="removeFiles && download ? 'col-2' : 'col-1'"
        *ngIf="!isDisabled"
    >
        <button
            *ngIf="preview && isSupportedByArivis(file)"
            type="button"
            class="btn ca-btn-icon"
            (click)="$event.stopPropagation(); openViewer()"
            [title]="'GENERAL.PREVIEW' | translate"
        >
            <ca-icon name="eye-open" size="s"></ca-icon>
        </button>
        <button
            #filePreview
            *ngIf="preview && !isSupportedByArivis(file) && isSupportedByFilePreviewer(file)"
            type="button"
            class="btn ca-btn-icon"
            (click)="$event.stopPropagation(); previewOutput()"
            [title]="'GENERAL.PREVIEW' | translate"
        >
            <ca-icon name="eye-open" size="s"></ca-icon>
        </button>
        <ca-file-download-btn *ngIf="download" (onClick)="downloadFile()"></ca-file-download-btn>
        <button
            *ngIf="removeFiles"
            data-uit="ca-delete-input-file"
            type="button"
            class="btn ca-btn-icon"
            (click)="$event.stopPropagation(); remove(file)"
            [title]="'GENERAL.REMOVE' | translate"
        >
            <ca-icon *ngIf="!useTrashIcon" name="cross" size="s"></ca-icon>
            <ca-icon *ngIf="useTrashIcon" name="trash" size="s"></ca-icon>
        </button>
    </div>
</div>
